import React from "react";
import { useLanguage } from '../context/LanguageContext';
import "../styles/marques-within-network.css";

const ROW1 = [
  { src: "/images/marques/logo-ferrari.png", alt: "Ferrari" },
  { src: "/images/marques/logo-porsche.png", alt: "Porsche" },
  { src: "/images/marques/logo-lamborghini.png", alt: "Lamborghini" },
  { src: "/images/marques/logo-mclaren.png", alt: "McLaren" },
  { src: "/images/marques/logo-rolls-royce.png", alt: "Rolls-Royce" },
];

const ROW2 = [
  { src: "/images/marques/logo-aston-martin.png", alt: "Aston Martin" },
  { src: "/images/marques/logo-bugatti.png", alt: "Bugatti" },
  { src: "/images/marques/logo-pagani.png", alt: "Pagani" },
  { src: "/images/marques/logo-bentley.png", alt: "Bentley" },
];

const translations = {
  en: { title: 'Marques Within the Network', text: 'We work across the world\'s most respected marques\u2014through trusted relationships within the global collector market.' },
  es: { title: 'Marcas Dentro de la Red', text: 'Trabajamos con las marcas m\u00e1s respetadas del mundo\u2014a trav\u00e9s de relaciones de confianza dentro del mercado global de coleccionistas.' },
  pt: { title: 'Marcas Dentro da Rede', text: 'Trabalhamos com as marcas mais respeitadas do mundo\u2014por meio de relacionamentos de confian\u00e7a no mercado global de colecionadores.' },
  fr: { title: 'Marques au sein du R\u00e9seau', text: 'Nous travaillons avec les marques les plus respect\u00e9es au monde\u2014\u00e0 travers des relations de confiance au sein du march\u00e9 mondial des collectionneurs.' },
  it: { title: 'Marchi All\u2019interno della Rete', text: 'Lavoriamo con i marchi pi\u00f9 rispettati al mondo\u2014attraverso relazioni di fiducia nel mercato globale dei collezionisti.' },
};

export default function MarquesWithinNetwork() {
  const { language } = useLanguage();
  const t = translations[language] || translations.en;

  return (
    <section className="marques-section" aria-labelledby="marques-title">
      <div className="marques-bg" aria-hidden="true" />
      <div className="marques-overlay" aria-hidden="true" />

      <div className="marques-inner">
        <header className="marques-copy">
          <h2 id="marques-title" className="marques-title">{t.title}</h2>
          <p className="marques-text">{t.text}</p>
        </header>

        <div className="marques-panel" role="group" aria-label="Marques within the network">
          <div className="marques-logos-grid">
            <div className="marques-logos-row">
              {ROW1.map((logo) => (
                <img
                  key={logo.alt}
                  className="marque-logo"
                  src={logo.src}
                  alt={logo.alt}
                  loading="eager"
                  decoding="async"
                  draggable="false"
                />
              ))}
            </div>
            <div className="marques-logos-row">
              {ROW2.map((logo) => (
                <img
                  key={logo.alt}
                  className="marque-logo"
                  src={logo.src}
                  alt={logo.alt}
                  loading="eager"
                  decoding="async"
                  draggable="false"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
